import { render } from "./workOrderHistoryList.vue?vue&type=template&id=70e2c8f7&scoped=true"
import script from "./workOrderHistoryList.vue?vue&type=script&lang=js"
export * from "./workOrderHistoryList.vue?vue&type=script&lang=js"

import "./workOrderHistoryList.vue?vue&type=style&index=0&id=70e2c8f7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e2c8f7"]])

export default __exports__